import React from "react";
import Container from "../ui/Container";
import Button from "../ui/Button";
import Icon from "../ui/Icon";

/**
 * "Give Us The Chance To Service You" request-a-quote band.
 * Reused across the home page and (optionally) service pages.
 */
const QuoteCta = ({
  title = "Give Us The Chance To Service You",
  subtitle = "Tell us about your shipment and our team will get back to you with a tailored quote.",
}) => (
  <section className="relative overflow-hidden bg-primary-container">
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.2),transparent_70%)]" />
    <Container className="relative flex flex-col items-center gap-6 py-16 text-center">
      <h2 className="max-w-3xl font-headline-xl text-3xl uppercase tracking-tight text-white md:text-headline-xl">
        {title}
      </h2>
      <p className="max-w-2xl font-body-lg text-body-lg text-white/90">{subtitle}</p>
      <Button
        to="/contact"
        variant="secondary"
        className="border-white bg-white text-primary hover:bg-transparent hover:text-white"
      >
        Request a Quote
        <Icon name="arrow_forward" className="text-lg" />
      </Button>
    </Container>
  </section>
);

export default QuoteCta;
